import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Button } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { UpperCaseTextCellEditor } from "./TextCustomCellEditor";

const AssetType = () => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.assetType}`;
    const gridRef = useRef();
    const perPage = 10;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [updateData, setUpdateData] = useState([]);
    const [error, setError] = useState("")
    const [gridApi, setGridApi] = useState(null);
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'displayName', enableRowGroup: true, cellEditor: UpperCaseTextCellEditor },
        { field: 'category', enableRowGroup: true, },

    ]);

    const getAssetTypes = async () => {
        try {
            const res = await OAuthService.getList(url + '?sort=cityName,asc&size=1000');
            const assetTypes = res?.data?._embedded?.assetTypes;
            setRowData(assetTypes);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    const onGridReady = useCallback((params) => {
        setGridApi(params)
        getAssetTypes();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'AssetTypes.xlsx',
            sheetName: 'AssetTypes'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                getAssetTypes();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows]);

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // updateData.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'displayName')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'displayName',
            });
        }, 800);
    }, [updateData]);
    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'displayName')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'displayName',
        });

    }, [updateData]);

    const onBtCopyRow = useCallback((event) => {
        const data = event.node.data;
        const copyRow = {
            displayName: data.displayName,
            category: data.category
        }
        const newRowDate = gridRef.current.api.applyTransaction({ add: [copyRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        rowData.splice(RowIndex, 0, copyRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'displayName')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'displayName',
            });
        }, 800);
    }, [rowData]);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        rowData.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
        selectedRow.map(async (row) => {
            await OAuthService.deleteData(url, row.id);
        })
    }, [gridApi, rowData])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: data ? false : true,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            {
                name: "Copy Row",
                disabled: data ? false : true,
                icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
                action: () => {
                    onBtCopyRow(event);
                },
            },
            {
                name: "Delete Row",
                disabled: data ? false : true,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const model = {
            id: data.id ? data.id : null,
            displayName: data.displayName,
            category: data.category,
            rowIndex: event.node.rowIndex
        }
        if (updateData.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
            const updatedData = updateData.map((item) => {
                if (item.rowIndex === event.node.rowIndex) {
                    item.displayName = data.displayName;
                    item.category = data.category;
                }
                return item;
            })
            setUpdateData(updatedData);
        } else {
            setUpdateData([...updateData, model]);
        }

    }, [updateData])
    console.log('updateData===>', updateData);


    /* -----------------------------------------save row button component ---------------------------------------------- */

    const SaveRowBtn = () => {

        const handleSubmit = async () => {
            try {
                updateData.map(async (data) => {
                    if (data.id) {
                        if (data.displayName && data.category) {
                            const responce = await OAuthService.updateData(url, data.id, data);
                            if (responce.status === 200) {
                                setSuccessMsg("Update data successfully");
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 1000);
                            }
                        } else {
                            setSuccessMsg("Please fill in the blank");
                            setSnackState(true);
                            setTimeout(() => { setSnackState(false) }, 1000)
                        }
                    } else {
                        if (data.displayName && data.category) {
                            const responce = await OAuthService.addData(url, data);
                            if (responce.status === 201) {
                                setSuccessMsg("Data saved successfully");
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 1000);
                            }
                        } else {
                            setSuccessMsg("Please fill in the blank");
                            setSnackState(true);
                            setTimeout(() => { setSnackState(false) }, 1000);
                        }
                    }
                });
                setUpdateData([]);

            } catch (error) {

            }
        }

        return (
            <Button
                variant="contained"
                color="warning"
                onClick={handleSubmit}
                disabled={updateData.length > 0 ? false : true}
                style={{ marginBottom: '5px', fontWeight: 'bold' }}
            >
                <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
            </Button>
        );
    }


    return (
        <>
            <ListPageHeader
                componentName="AssetTypes"
                headerInputFields={SaveRowBtn()}
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    // onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    editable={true}
                    editType={'fullRow'}
                    onRowValueChanged={onRowValueChanged}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'AssetTypes'}
                />
            </div>
        </>
    )
}

export default AssetType